import React from "react";

const Icon = ({ name }) => {
  if (name === "check") {
    return (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path
          d="M5 12l4 4L19 6"
          stroke="currentColor"
          strokeWidth="2.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
  return null;
};

/**
 * 緑ボタンコンポーネント
 * @param {string} title ボタンタイトル
 * @param {String} icon アイコン
 * @param {Function} onClick ボタン押下時の処理
 * @param {string} className クラス名
 * @class GreenButton
 */
export default function GreenButton({ title, icon, onClick, className = "" }) {
  return (
    <button className={`btn btn-green ${className}`} onClick={onClick}>
      <Icon name={icon} />
      {title}
    </button>
  );
}
